<!-- Choose company -->
<mat-card style="margin-top: 30px">
  <mat-card-content>
    @if (showProtocols) {
      <section class="fab-section">
        <div class="fab-row">
          <button
            #pushMigration
            mat-fab
            extended
            class="success-btn"
            (click)="publishMigrationClicked()"
            [disabled]="!shouldEnableMigrationCommands || loading"
            [class.gray-out]="!shouldEnableMigrationCommands || loading"
          >
            <mat-icon>queue</mat-icon>
            Queue Migration
          </button>

          <button
            mat-fab
            extended
            class="warning-btn"
            (click)="rejectMigrationClicked()"
            [disabled]="
              !shouldEnableMigrationCommands ||
              !shouldEnableRejectionCommands ||
              loading
            "
            [class.gray-out]="
              !shouldEnableMigrationCommands ||
              !shouldEnableRejectionCommands ||
              loading
            "
          >
            <mat-icon>block</mat-icon>
            Reject Migration
          </button>

          @if (
            shouldShowRemigrateMigrationCommands && isRemigrationFeatureEnabled
          ) {
            <button
              mat-fab
              extended
              class="mat-primary-second-light"
              (click)="remigrateMigrationClicked()"
              [disabled]="!shouldEnableRemigrateCommands || loading"
              [class.gray-out]="!shouldEnableRemigrateCommands || loading"
            >
              <mat-icon>autorenew</mat-icon>
              {{ remigrateButtonLabel }}
            </button>
          }
        </div>
      </section>
    }
    <app-search-select
      (selectionChange)="companySelectionChanged($event)"
      [loading]="loading"
    ></app-search-select>
  </mat-card-content>
  @if (
    company?.company_name &&
    (company?.has_irbnet_sites || company?.can_be_remigrated)
  ) {
    <mat-card-footer>
      *{{ company?.company_name }}
      @if (company?.has_irbnet_sites) {
        has IRBNet sites
      }
      @if (company?.has_irbnet_sites && company?.can_be_remigrated) {
        and
      }
      @if (company?.can_be_remigrated) {
        is eligible for remigration. To remigrate choose at least one protocol.
        If specific sites are selected, only those sites will be remigrated.
        Otherwise, all sites will be remigrated.
      }
    </mat-card-footer>
  }
</mat-card>

<!-- Display protocols -->
@if (showProtocols) {
  <mat-card>
    <mat-card-content>
      <mat-tab-group
        [selectedIndex]="selectedTabIndex"
        (selectedTabChange)="onTabChange($event)"
      >
        <mat-tab label="Studies">
          <div class="tab-content">
            <app-table-grid
              [data]="protocolsPaginated"
              [columnsLink]="columnsLink"
              (cellClicked)="protocolCellClicked($event)"
              [displayedColumns]="
                shouldShowRemigrateMigrationCommands
                  ? filteredProtocolsColumns
                  : filteredProtocolsColumns.slice(1)
              "
              [headers]="
                shouldShowRemigrateMigrationCommands
                  ? filteredProtocolsTableHeaders
                  : filteredProtocolsTableHeaders.slice(1)
              "
              [columnWidths]="
                shouldShowRemigrateMigrationCommands
                  ? filteredProtocolsColumnWidths
                  : filteredProtocolsColumnWidths.slice(1)
              "
              [customStyle]="
                'font-family: monospace;font-size: 11px;max-width: 650px;'
              "
              [isLoading]="loadingTable"
              [skeletonRowsCount]="
                protocolsPaginated.length < paginatorFilter.pageSize
                  ? protocolsPaginated.length
                  : paginatorFilter.pageSize
              "
              [enableSorting]="true"
              [serverSideSorting]="true"
              [columnSortTypes]="protocolColumnSortTypes"
              [defaultSortColumn]="protocolSort.active"
              [defaultSortDirection]="protocolSort.direction"
              [customBoolTrueColor]="'#00B4ED'"
              [customBoolWithFalseColumn]="'migrated'"
              [customBoolColumn]="'has_irbnet_sites'"
              [selectColumn]="
                shouldShowRemigrateMigrationCommands ? 'select' : ''
              "
              [selectEnabledColumn]="'canSelect'"
              (selectionChanged)="protocolSelectionChanged($event)"
              (sortChanged)="onProtocolSortChanged($event)"
            ></app-table-grid>

            @if (protocols.length && !loading) {
              <mat-paginator
                showFirstLastButtons="true"
                [length]="paginatorFilter.count"
                [pageIndex]="paginatorFilter.currentPage"
                [pageSize]="paginatorFilter.pageSize"
                [pageSizeOptions]="[5, 10, 25, 100]"
                (page)="paginateProtocols($event)"
                class="mat-elevation-z8"
              >
              </mat-paginator>
            }
          </div>
        </mat-tab>

        @if (isSitesRemigrationEnabled) {
          <mat-tab label="Sites">
            <div class="tab-content">
              <app-table-grid
                [data]="sitesPaginated"
                [columnsLink]="siteColumnsLink"
                (cellClicked)="siteCellClicked($event)"
                [displayedColumns]="filteredSitesColumns"
                [headers]="filteredSitesTableHeaders"
                [columnWidths]="filteredSitesColumnWidths"
                [selectColumn]="shouldShowSiteSelectColumn ? 'select' : ''"
                [selectEnabledColumn]="'canSelect'"
                [enableSorting]="true"
                [serverSideSorting]="true"
                [columnSortTypes]="siteColumnSortTypes"
                [defaultSortColumn]="siteSort.active"
                [defaultSortDirection]="siteSort.direction"
                [customBoolWithFalseColumn]="'migrated'"
                [customStyle]="
                  'font-family: monospace;font-size: 11px;max-width: 650px;'
                "
                [isLoading]="loadingSitesTable"
                [skeletonRowsCount]="
                  sitesPaginated.length < sitesPaginatorFilter.pageSize
                    ? sitesPaginated.length
                    : sitesPaginatorFilter.pageSize
                "
                (selectionChanged)="siteSelectionChanged($event)"
                (sortChanged)="onSiteSortChanged($event)"
              ></app-table-grid>

              @if (sites.length && !loadingSitesTable) {
                <mat-paginator
                  showFirstLastButtons="true"
                  [length]="sitesPaginatorFilter.count"
                  [pageIndex]="sitesPaginatorFilter.currentPage"
                  [pageSize]="sitesPaginatorFilter.pageSize"
                  [pageSizeOptions]="[5, 10, 25, 100]"
                  (page)="paginateSites($event)"
                  class="mat-elevation-z8"
                >
                </mat-paginator>
              }
            </div>
          </mat-tab>
        }
      </mat-tab-group>
    </mat-card-content>
    @if (company?.company_name) {
      <mat-card-footer>
        *all {{ selectedTabIndex === 1 ? "sites" : "protocols" }} for
        {{ company?.company_name }}
        @if (cutoff_date && selectedTabIndex === 0) {
          have the cutoff date: {{ cutoff_date | date:'shortDate' }}
        }
      </mat-card-footer>
    }
  </mat-card>
}
